module.exports = __webpack_public_path__ + "static/media/sciencefiction.736072f6.jpg";